import { Pressable, StyleSheet, View } from 'react-native';
import { ColorValues, IconClose, Typography } from '@banhala/ui-kit';
import { IconAiContent } from './IconAiContent';

const ICON_SIZE = 24;
const CLOSE_ICON_SIZE = 20;
// 도킹된 구매 버튼과 진입점 사이 간격
const BOTTOM_GAP = 16;

interface AiContentDraftFloatingButtonProps {
  onPress: () => void;
  onClose: () => void;
}

export const AiContentDraftFloatingButton = ({
  onPress,
  onClose,
}: AiContentDraftFloatingButtonProps) => {
  return (
    <Pressable onPress={onPress} style={styles.container}>
      <IconAiContent size={ICON_SIZE} />
      <View style={styles.textArea}>
        <Typography type="body2" color="content_always_white">
          이 상품으로 콘텐츠 초안 만들기
        </Typography>
      </View>
      <Pressable onPress={onClose} style={styles.closeTouchArea}>
        <IconClose size={CLOSE_ICON_SIZE} fill={ColorValues.white} />
      </Pressable>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: BOTTOM_GAP,
    left: 12,
    right: 12,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingLeft: 16,
    paddingRight: 4,
    paddingVertical: 4,
    borderRadius: 12,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  textArea: {
    flex: 1,
  },
  closeTouchArea: {
    padding: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
